import { useState } from 'react';

import { Modal } from '@components/Page';

import OrganizationsList from './OrganizationsList';

const LABEL_TITLE = 'Switch To';

type ModalControls = {
  open?: () => void;
};

type ModalRef = {
  current: ModalControls;
};

type Props = {
  modal: ModalRef;
};

const OrganizationsModal = ({ modal }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  modal.current.open = () => setIsOpen(true);

  const onClose = () => {
    setIsOpen(false);
  };

  const modalProps = {
    title: LABEL_TITLE,
    destroyOnClose: true,
    isOpen,
    onClose,
  };

  const organizationListProps = {
    onAfterSwitch: () => onClose(),
  };

  return (
    <Modal {...modalProps}>
      <OrganizationsList {...organizationListProps} />
    </Modal>
  );
};

export default OrganizationsModal;
